import * as array from 'd3-array'
import * as scale from 'd3-scale'

function getRange (dimensions, types) {
  // This is kind of a sloppy approach, but
  // since polar is currently the only one-off chart, we'll wait
  // to see how other chart types evolve
  if (types.length == 1 && types[0] === 'polar') {
    const extraPaddingX = 50 // In addition to global padding n index.js. This is artificially large to accommodate longer titles
        , extraPaddingY = 35 // In addition to global padding n index.js.
        , width = dimensions.width - (extraPaddingX * 2)
        , height = dimensions.height - (extraPaddingY * 2)
        , radius = Math.min(width, height) / 2

    return [0, radius]
  } else {
    // Default
    // Prevent a negative height so labels don't overlap
    return [Math.max(0, dimensions.height), 0]
  }
}

/*
 * Returns an object containing the y scalers for this graph and its height
 */
export default function (data, layout, dimensions) {
  let axes = data.plots.reduce((p, c) => {
                    c.series.forEach(serie => {
                      if (serie.axis === 'right') {
                        p.right.push(serie)
                      } else  {
                        if (['pie', 'donut'].indexOf(serie.type) === -1) {
                          // only set the left axis or default (which is left) if it's a cartesian style
                          p.left.push(serie)
                        }
                      }
                    })

                    return p
                  }, { right: [], left: [] })
    , scalers = {}
    , nice = true
    , singleAxis = !(!!axes.right.length && !!axes.left.length)

  let build = function () {
    Object.keys(axes).forEach(function (axis) {
      let s = axes[axis]
        , nonAnalyticSeries = layout.nonAnalyticsSeries(s)

      if (s.length) {
        let discrete = false
          , range = data.plots[0].breakdown ? data.plots[0].breakdown.range : [] // We currently assume all plots have the same breakdown
          , min = layout.minValue(axis)
          , max = layout.maxValue(axis)

        // If we're showing boolean data...
        if (typeof min === 'boolean' || typeof max === 'boolean') {
          discrete = true

          // and the min max is the same
          if (min === max) {
            // Override it, so we show both labels
            // TODO Order may end up being dependent on incoming data based on "Is yes good"
            min = 0
            max = 1
          }
        }

        var r = max - min || 1
          , maxY = max + (r * 0.05) // Default padding of 5%
          , minY = min

        // Pad the bottom axis if we're only showing line charts (See #143) and a single axis
        if (singleAxis && nonAnalyticSeries.length === 1 && nonAnalyticSeries[0].type === 'line') {
          minY -= (r * 0.02)
        }

        [minY, maxY] = layout.yScaleOverrides(axis, minY, maxY)

        scalers[axis] = scale.scaleLinear()
                             .range(getRange(dimensions, layout.getTypes()))
                             .domain([minY, maxY])

        // Store the original range extent on the scaler in case code needs to know
        // the unpadded values
        scalers[axis]._domain = [min, max]
        scalers[axis]._discrete = discrete

        if (nice) {
          scalers[axis].nice()
        }

        if (axes.right.length === 1 && axes.left.length === 1) {
          scalers[axis].color = s[0].color
        }
      }
    })

    return scalers
  }

  build.nice = function (arg) {
    if (!arguments) {
      return nice
    }
    nice = arg
    return this
  }

  return build

}
